import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import RefreshIcon from '@material-ui/icons/Refresh';

import _ from 'lodash';
import { getEntitiesArray } from '../../../reducers/entitiesReducer';
import { successColor, dangerColor } from '../../../assets/jss/material-dashboard-pro-react';
import DefaultTable from '../../general/conf-table/ConfTable';
import clientSpreadsheetActions from '../../../actions/clientSpreadsheetActions';
import clientSpreadsheetTableColumns from './clientSpreadsheetTableColumns';
import notificationActions from '../../general/notification/NotificationsManager/actions';
import popupActions from '../../general/popup/PopupsManager/actions';
import cacheActions from '../../../actions/cacheActions';

class ClientSpreadsheetsTable extends Component {

  state = {
    id: `${Math.random()}`,
  };

  operations = [
    {
      title: 'Excluir',
      content: <CloseIcon fontSize="small" nativeColor={dangerColor} />,
      execute: row => this.onRowDelete(row.id),
    },
    {
      title: 'Reimportar',
      content: <RefreshIcon nativeColor={successColor} />,
      execute: row => this.onRowReimport(row.id),
    },
  ];

  componentWillMount() {
    this.onMount();
  }

  fetchClientSpreadsheets = () => this.props.dispatch(clientSpreadsheetActions.fetchAll());

  reimportClientSpreadsheet = id => this.props.dispatch(clientSpreadsheetActions.reimport(id));

  deleteClientSpreadsheet = id => this.props.dispatch(clientSpreadsheetActions.delete(id));

  onMount = () => {
    this.props.dispatch(cacheActions.cleanCache());
    this.fetchClientSpreadsheets()
      .catch(this.onOperationFail);
  };

  onRowReimport = (id) => {
    this.reimportClientSpreadsheet(id)
      .then(this.onReimportSucceed)
      .catch(this.onOperationFail);
  };

  onRowDelete = (id) => {
    this.deleteClientSpreadsheet(id)
      .then(this.onDeleteSucceed)
      .catch(this.onOperationFail);
  };

  onOperationFail = apiResponse => this.props.dispatch(popupActions.handleApiResponse(apiResponse));

  onReimportSucceed = () => {
    const { dispatch } = this.props;
    const message = 'A planilha foi reimportada com sucesso.';
    dispatch(notificationActions.showSuccessNotification(message));
  };

  onDeleteSucceed = () => {
    const { dispatch } = this.props;
    const message = 'A planilha foi excluída com sucesso.';
    dispatch(notificationActions.showSuccessNotification(message));
  };

  render() {
    let { clientSpreadsheets } = this.props;
    clientSpreadsheets = _.sortBy(clientSpreadsheets, 'id').reverse();
    const { id } = this.state;
    return (
      <DefaultTable
        id={id}
        columns={clientSpreadsheetTableColumns}
        dataList={clientSpreadsheets}
        operations={this.operations}
      />
    );
  }
}

ClientSpreadsheetsTable.propTypes = {
  dispatch: PropTypes.func.isRequired,
  clientSpreadsheets: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  clientSpreadsheets: getEntitiesArray('clientSpreadsheets')(state),
});

export default connect(mapStateToProps)(ClientSpreadsheetsTable);
